import { Absent_getInstance3t0okspv6nz5y as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePartyInputClass;
function SavePartyInput() {
  if (SavePartyInputClass === VOID) {
    class $ {
      constructor(partyId, name, email, pairingRule, badgesEnabled, defaultBadgeName, alternateBadgeName, callSignsEnabled, animationsEnabled, animationSpeed) {
        name = name === VOID ? Absent_getInstance() : name;
        email = email === VOID ? Absent_getInstance() : email;
        pairingRule = pairingRule === VOID ? Absent_getInstance() : pairingRule;
        badgesEnabled = badgesEnabled === VOID ? Absent_getInstance() : badgesEnabled;
        defaultBadgeName = defaultBadgeName === VOID ? Absent_getInstance() : defaultBadgeName;
        alternateBadgeName = alternateBadgeName === VOID ? Absent_getInstance() : alternateBadgeName;
        callSignsEnabled = callSignsEnabled === VOID ? Absent_getInstance() : callSignsEnabled;
        animationsEnabled = animationsEnabled === VOID ? Absent_getInstance() : animationsEnabled;
        animationSpeed = animationSpeed === VOID ? Absent_getInstance() : animationSpeed;
        this.z6p_1 = partyId;
        this.a6q_1 = name;
        this.b6q_1 = email;
        this.c6q_1 = pairingRule;
        this.d6q_1 = badgesEnabled;
        this.e6q_1 = defaultBadgeName;
        this.f6q_1 = alternateBadgeName;
        this.g6q_1 = callSignsEnabled;
        this.h6q_1 = animationsEnabled;
        this.i6q_1 = animationSpeed;
      }
      toString() {
        return 'SavePartyInput(partyId=' + this.z6p_1.toString() + ', name=' + toString(this.a6q_1) + ', email=' + toString(this.b6q_1) + ', pairingRule=' + toString(this.c6q_1) + ', badgesEnabled=' + toString(this.d6q_1) + ', defaultBadgeName=' + toString(this.e6q_1) + ', alternateBadgeName=' + toString(this.f6q_1) + ', callSignsEnabled=' + toString(this.g6q_1) + ', animationsEnabled=' + toString(this.h6q_1) + ', animationSpeed=' + toString(this.i6q_1) + ')';
      }
      hashCode() {
        var result = this.z6p_1.hashCode();
        result = imul(result, 31) + hashCode(this.a6q_1) | 0;
        result = imul(result, 31) + hashCode(this.b6q_1) | 0;
        result = imul(result, 31) + hashCode(this.c6q_1) | 0;
        result = imul(result, 31) + hashCode(this.d6q_1) | 0;
        result = imul(result, 31) + hashCode(this.e6q_1) | 0;
        result = imul(result, 31) + hashCode(this.f6q_1) | 0;
        result = imul(result, 31) + hashCode(this.g6q_1) | 0;
        result = imul(result, 31) + hashCode(this.h6q_1) | 0;
        result = imul(result, 31) + hashCode(this.i6q_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePartyInput()))
          return false;
        if (!this.z6p_1.equals(other.z6p_1))
          return false;
        if (!equals(this.a6q_1, other.a6q_1))
          return false;
        if (!equals(this.b6q_1, other.b6q_1))
          return false;
        if (!equals(this.c6q_1, other.c6q_1))
          return false;
        if (!equals(this.d6q_1, other.d6q_1))
          return false;
        if (!equals(this.e6q_1, other.e6q_1))
          return false;
        if (!equals(this.f6q_1, other.f6q_1))
          return false;
        if (!equals(this.g6q_1, other.g6q_1))
          return false;
        if (!equals(this.h6q_1, other.h6q_1))
          return false;
        if (!equals(this.i6q_1, other.i6q_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePartyInput');
    SavePartyInputClass = $;
  }
  return SavePartyInputClass;
}
//region block: exports
export {
  SavePartyInput as SavePartyInput3ikp23en56cie,
};
//endregion

//# sourceMappingURL=SavePartyInput.mjs.map
